import noop from 'lodash/noop';

import { RouteOverrideFunction } from '../types/RouteOverrideFunction';

export const defaultOverrideFunction: RouteOverrideFunction = noop;
